import { servicosSaudeCidadesApi } from "@/api/ServicosSaudeCidadesApi";
import CidadeFiltro from "@/models/cadastros/saude/CidadeFiltro";
import CidadeModel from "@/models/cadastros/saude/CidadeModel";

class SaudeCidadeService {
  pesquisar(filtro?: CidadeFiltro) {
    const filtroDTO = {
      nome: filtro?.nome,
      estado: filtro?.estado?.sigla,
      number: filtro?.options?.page,
      size: filtro?.options?.itemsLength,
      sort: "nome",
    };
    return servicosSaudeCidadesApi.obterCidade(filtroDTO);
  }

  salvar(cidade: CidadeModel) {
    const cidadeDTO = {
      nome: cidade.nome,
      estado: cidade.estado?.sigla,
    };

    return servicosSaudeCidadesApi.salvarCidade(cidadeDTO);
  }

  atualizar(cidade: CidadeModel, idCidade: Number) {
    const cidadeDTO = {
      nome: cidade.nome,
      estado: cidade.estado?.sigla,
    };
    return servicosSaudeCidadesApi.atualizarCidade(idCidade, cidadeDTO);
  }

  obterPorId(idCidade: Number) {
    return servicosSaudeCidadesApi.obterCidadePorId(idCidade);
  }

  obterCidadesPorEstado(uf?: string) {
    return servicosSaudeCidadesApi.obterCidadesPorEstado(uf);
  }

  deletar(idCidade: Number) {
    return servicosSaudeCidadesApi.deletarCidade(idCidade);
  }
}

export const saudeCidadeService = new SaudeCidadeService();
